import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wheat',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM-1.5,-0.5h1v0.5h-1zM0.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'owl',
      d: 'M-2,-4.5h1v0.5h-1zM1,-4.5h0.5v0.5h-0.5zM-1.5,-4h3v0.5h-3zM-1.5,-3.5h0.5v1h-0.5zM1,-3.5h0.5v1.5h-0.5zM-1.5,-2.5h1v1.5h-1zM0.5,-1.5h1v0.5h-1zM-1.5,-1h2.5v0.5h-2.5zM-0.5,-0.5h1v0.5h-1z',
    },
    { paint: 'trunk', d: 'M0.5,-2.5h0.5v0.5h-0.5zM0.5,-2h1v0.5h-1z' },
    { paint: 'mushroom', d: 'M-1,-3.5h0.5v0.5h-0.5zM0,-3.5h1v0.5h-1zM-0.5,-3h1v0.5h-1z' },
    { paint: 'fence', d: 'M-1,-3h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM-0.5,-2h1v1h-1z' },
  ],
  pixels: 49,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
